import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { DEFAULT_COMMISSION_VALUE } from "../detail/Commissions";
import { DEFAULT_VALUE } from "../detail/PackagePrices";
import {
	BENEFIT_CODE,
	BENEFIT_TYPE,
	PACKAGE_STATUS,
	SubscriptionPackage,
	SubscriptionPackageParams,
} from "../type";

interface SubscriptionPackageState {
	subscriptionPackageList: Array<SubscriptionPackage>;
	subscriptionPackageTotal: number;
}

export const subscriptionPackageDefault: Partial<SubscriptionPackage> = {
	name: {
		en: "",
		km: "",
		zh: "",
	},
	prices: [DEFAULT_VALUE],
	benefits: [
		{
			code: BENEFIT_CODE.CAR_PORT,
			type: BENEFIT_TYPE.MAIN,
			quota: 0,
			hidden: true,
		},
		{
			code: BENEFIT_CODE.HOT_SALE,
			type: BENEFIT_TYPE.MAIN,
			quota: 0,
			duration: 0,
			hidden: true,
		},
		{
			code: BENEFIT_CODE.CHAT_WITH_PROSPECTS,
			type: BENEFIT_TYPE.OTHER,
			hidden: true,
		},
		{
			type: BENEFIT_TYPE.OTHER,
			code: BENEFIT_CODE.CHECK_CAR,
			hidden: true,
		},
		{
			type: BENEFIT_TYPE.OTHER,
			code: BENEFIT_CODE.REQUEST_AUCTION,
			hidden: true,
		},
		{
			type: BENEFIT_TYPE.OTHER,
			code: BENEFIT_CODE.COMMUNITY,
			hidden: true,
		},
		{
			type: BENEFIT_TYPE.OTHER,
			code: BENEFIT_CODE.UNLIMITED_POST_TOP_DEAL,
			hidden: true,
		},
		{
			type: BENEFIT_TYPE.OTHER,
			code: BENEFIT_CODE.SALE_SUPPORT,
			hidden: true,
		},
		{
			type: BENEFIT_TYPE.OTHER,
			code: BENEFIT_CODE.CUSTOMER_SERVICE_SUPPORT,
			hidden: true,
		},
		{
			type: BENEFIT_TYPE.OTHER,
			code: BENEFIT_CODE.DIGITAL_MEDIA_SUPPORT,
			hidden: true,
		},
	],
	status: PACKAGE_STATUS.ENABLED,
	isBestSeller: false,
	icon: "",
	type: "",
	ordinal: 0,
	annualMembership: 0,
	commissions: [DEFAULT_COMMISSION_VALUE],
};

const initialState: SubscriptionPackageState = {
	subscriptionPackageList: [],
	subscriptionPackageTotal: 0,
};

export const subscriptionPackageSlice = createSlice({
	name: "subscriptionPackage",
	initialState,
	reducers: {
		setListSubscriptionPackage: (state, action) => {
			state.subscriptionPackageList = action.payload.data;
			state.subscriptionPackageTotal = action.payload.total;
		},
	},
});

export const selectSubscriptionPackageList = (state: RootState) =>
	state.subscriptionPackage.subscriptionPackageList;
export const selectSubscriptionPackageTotal = (state: RootState) =>
	state.subscriptionPackage.subscriptionPackageTotal;

export const { setListSubscriptionPackage } = subscriptionPackageSlice.actions;

export interface GetListSubscriptionPackageAsyncPayload {
	query: SubscriptionPackageParams;
	callback?: () => void;
}

export const getListSubscriptionPackageAsync = createAction(
	"subscriptionPackage/getListSubscriptionPackageAsync",
	(payload: GetListSubscriptionPackageAsyncPayload) => ({
		payload: payload || {},
	}),
);

export default subscriptionPackageSlice.reducer;
